import { jsxs, jsx } from 'react/jsx-runtime';
import { cn } from '@repo/lib';

const dots = "animate-ping bg-muted-foreground inline-block rounded-md size-1";
function LoadingDots({ className }) {
    return /*#__PURE__*/ jsxs("span", {
        className: cn("mx-2 inline-flex items-center gap-2", className),
        children: [
            /*#__PURE__*/ jsx("span", {
                className: cn(dots, "animation-delay-none")
            }),
            /*#__PURE__*/ jsx("span", {
                className: cn(dots, "animation-delay-150")
            }),
            /*#__PURE__*/ jsx("span", {
                className: cn(dots, "animation-delay-300")
            })
        ]
    });
}

export { LoadingDots };
